export default {
  path: '/payment',
  meta: {
    title: '收款信息',
  },
  component: r => require.ensure([], () => r(require(`./index.vue`)), `/payment`),
}



// WEBPACK FOOTER //
// ./src/views/Payment/router.js